import useFeatures from 'hooks/useFeatures';
import useAppUser from '../../../../hooks/useAppUser';
import useHasRouteAccess from '../../../../router/useHasRouteAccess';
import { itemsByRole } from './headerItemsConstants';

const useHeaderItems = () => {
  const hasRouteAccess = useHasRouteAccess();
  // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const hasItemAccess = (item) => hasRouteAccess(item.path);
  const allowedFlags = useFeatures();
  const { userType } = useAppUser();
  // @ts-expect-error TS2538 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const navigationProps = { ...itemsByRole[userType] };
  navigationProps.navItems = navigationProps.navItems
    .filter(hasItemAccess)
    .filter(
      // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      ({ allowedToRender }) =>
        !allowedToRender || allowedToRender(allowedFlags),
    );

  navigationProps.dropdownItems = navigationProps.dropdownItems
    .filter(hasItemAccess)
    .filter(
      // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      ({ allowedToRender }) =>
        !allowedToRender || allowedToRender(allowedFlags),
    );
  navigationProps.dropdownSecondaryItems =
    navigationProps.dropdownSecondaryItems?.filter(hasItemAccess);
  return navigationProps;
};

export default useHeaderItems;
